import { render, staticRenderFns } from "./ContainerStatusSelector.vue?vue&type=template&id=65520d4d&scoped=true&"
import script from "./ContainerStatusSelector.vue?vue&type=script&lang=js&"
export * from "./ContainerStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65520d4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
